import { render } from "./RegisterWorkSchedules.vue?vue&type=template&id=2809ee20"
import script from "./RegisterWorkSchedules.vue?vue&type=script&lang=js"
export * from "./RegisterWorkSchedules.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__